import React from 'react';
const testimonials = [{
  stars: 5,
  text: '"Tuve cándida 5 veces en un año. El ginecólogo me dijo que era \'propensa\'. Después del protocolo de 72 horas, el alivio fue en menos de un día. Llevo 4 meses sin una sola recaída."',
  name: 'Valentina, 29',
  city: 'CABA'
}, {
  stars: 5,
  text: '"Lo mío era intestinal. Me hinchaba como si estuviera embarazada. Nadie me lo había relacionado con la cándida. Perdí 3 kilos de inflamación en 10 días."',
  name: 'Romina, 38',
  city: 'Rosario'
}, {
  stars: 5,
  text: '"Mi relación de pareja estaba sufriendo. El dolor me hacía evitar el contacto. Hoy eso es historia. Lo que más me sorprendió: lo simple que fue la lista de compras."',
  name: 'Lucía, 33',
  city: 'Córdoba'
}, {
  stars: 5,
  text: '"Después de 3 rondas de antibióticos, mi flora estaba destruida. La cándida volvía cada mes como un reloj. Con la Fase 2 del protocolo reconstruí todo en semanas. Hoy me siento otra persona."',
  name: 'Carolina, 27',
  city: 'Mendoza'
}, {
  stars: 5,
  text: '"Los antojos de dulce me controlaban la vida. No podía pasar una tarde sin comer algo azucarado. A los 10 días del protocolo, desaparecieron. Siento que recuperé el control de mi cuerpo."',
  name: 'Agustina, 41',
  city: 'La Plata'
}];
export function TestimonialsSection() {
  return <section className="w-full px-6 py-16 max-w-2xl mx-auto" data-id="element-233">
      <p className="text-brand-teal text-[11px] font-semibold uppercase tracking-widest mb-3" data-id="element-234">
        Ellas ya rompieron el ciclo
      </p>
      <h2 className="text-[24px] font-bold text-white mb-8 leading-tight" data-id="element-235">
        Lo que cambia cuando entendés la causa real
      </h2>

      <div className="flex flex-col gap-4 mb-6" data-id="element-236">
        {testimonials.map((t, i) => <div key={i} className="bg-white/[0.04] rounded-2xl p-5 border border-white/[0.08]" data-id="element-237">
            <div className="flex gap-0.5 mb-3" data-id="element-238">
              {Array.from({
            length: t.stars
          }).map((_, s) => <span key={s} className="text-yellow-400 text-base" data-id="element-239">
                  ⭐
                </span>)}
            </div>
            <p className="text-[15px] text-white/90 leading-relaxed mb-4" data-id="element-240">
              {t.text}
            </p>
            <p className="text-brand-muted text-sm font-semibold" data-id="element-241">
              — {t.name} · {t.city}
            </p>
          </div>)}
      </div>

      <p className="text-brand-muted text-[13px] text-center leading-relaxed" data-id="element-242">
        ⚠️ Los nombres fueron modificados para proteger la privacidad. Los casos
        son representativos del perfil de mujer con candidiasis recurrente sin
        complicaciones graves.
      </p>
    </section>;
}